// T203 — one filter bar.
//
// The dashboard and the applications board each grew their own: same rounded
// box, same flex-wrap, different radius, different padding, and — the part that
// mattered — only one of them ever told you how many rows survived the filters.
// On /applications you could set a search, a stage and a drill, see four short
// stage groups, and have no way to know whether that was 6 of 91 or 6 of 6.
//
// The controls stay with their page; only the chrome, the count and the reset
// live here. A filter bar is not a place to centralise page logic.

/**
 * @param {number}   [shown]   rows visible after filtering
 * @param {number}   [total]   rows before filtering
 * @param {boolean}  [dirty]   whether any filter is set (drives Reset)
 * @param {Function} [onReset] clears every filter the page owns
 * @param {string}   [noun]    plural noun for the count, e.g. "applications"
 */
export default function FilterBar({
  children, shown, total, dirty = false, onReset, noun = 'rows', className = '',
}) {
  const hasCount = Number.isFinite(shown) && Number.isFinite(total);
  return (
    <div
      className={
        'flex flex-wrap items-center gap-2 rounded-xl border border-slate-800 bg-slate-900/40 p-2.5 text-xs '
        + className
      }
    >
      {children}
      {(hasCount || (dirty && onReset)) && (
        <div className="ml-auto flex items-center gap-2 pl-1">
          {hasCount && (
            // aria-live: the count changes as a consequence of typing in the
            // search box, and a screen-reader user gets no other signal that
            // the list below them just went empty.
            <span role="status" aria-live="polite" className="tabular-nums text-slate-500">
              {shown === total
                ? `${total} ${noun}`
                : `Showing ${shown} of ${total} ${noun}`}
            </span>
          )}
          {dirty && onReset && (
            <button
              type="button"
              onClick={onReset}
              className="rounded-md border border-slate-700 px-2 py-1 text-slate-400 transition hover:border-brand-600 hover:text-brand-400"
            >
              Reset filters
            </button>
          )}
        </div>
      )}
    </div>
  );
}
